<template>
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group @reset="$gjReset" @query="$gjNoticeQuery">
        <gj-charger-select
          v-model="filter.chargeIds"
          collapse-tags
          placeholder="全部负责人"
          style="width: 175px"
        >
        </gj-charger-select>
        <gj-country-server-select
          v-model="filter.countryMarketValue"
        ></gj-country-server-select>
        <gj-select
          :options="financeCurrencysOptionMap"
          placeholder="币种"
          v-model="filter.currency"
          :clearable="false"
        ></gj-select>
        <gj-date-picker
          type="monthrange"
          :shortcuts="['本月', '上月']"
          :clearable="false"
          v-model="filter.date"
        ></gj-date-picker>
        <template #advancedFilter>
          <gj-select-input
            v-model="filter.keyword"
            :options="[
              { id: 'salesMoney', text: '销售额', conditionalOperation: true},
              { id: 'advertisingSpend', text: '广告花费', conditionalOperation: true},
              { id: 'purchaseCost', text: '采购成本', conditionalOperation: true},
              { id: 'arrivalCost', text: '到库成本', conditionalOperation: true},
              { id: 'salesGrossProfit', text: '销售毛利', conditionalOperation: true},
              { id: 'netSalesGrossProfit', text: '销售净毛利', conditionalOperation: true},
            ]"
            :optionsSymbol="[
              { id: 'GREATER', text: '>='},
              { id: 'LESS', text: '<='},
            ]"
            :width="['140px', '123px', '60px']"
          ></gj-select-input>
        </template>
        <template #right>
          <gj-tool-group
            :download="$permission('performanceReport:export')"
            download-url="/finance/financialPerformanceReport/export"
            :download-params="globalParams"
            help
            setting
            :sort-gjtable="$refs.gjTable"
            :table-name="tableName"
            :table-columns="columns"
          >
          </gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template #table>
      <gj-table
        tableType="static"
        adaptParent
        ref="gjTable"
        size="has-picture"
        show-summary :summary-object="pageData.summary"
        :name="tableName"
        :data="tableData"
        :columns="columnsMap"
        :loading="loading"
        :pagination="pagination"
        @page-change="$gjNoticeQuery"
      >
        <!-- 自定义cell -->
        <template v-slot:analysis="{ row }">
          <gj-icon
            iconfont="iconshuju1"
            class="analysis-icon"
            @click.native="handleNavigateShop(row)"
          ></gj-icon>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
import { isMeaningfulMixin, queryMixin, selectionMixin } from "@/minxins";
import { convertToFullDate } from "@/utils/date.util.js";
import { financeCurrencysOption } from "@/utils/options";
import { queryChargePerformanceReportResultList } from "@/api/finance";
import { DATE_SHORTCUTS } from "@/utils/const";
import HumanAnalysis from "./components/human-analysis";
export default {
  mixins: [queryMixin, selectionMixin, isMeaningfulMixin],
  name: "performance-report",
  data() {
    return {
      loading: false, // 加载
      groupType: "marketId",
      tableName: "performance-report",
      pageData: {}, // 包含表格数据和合计
      tableData: [], // 表格数据
      filter: {},
      columns: [
        {columnsInclude: ['index'],            id: "chargeName",header: "负责人",field: "chargeName",minWidth: "120px", disabled: true, fixed: "left", default: true},
        {columnsInclude: ['details'],          id: "month",header: "月份",field: "month",minWidth: "80px",fixed: "left",disabled: true, default: true},
        {columnsInclude: ['index'],            id: "analysis",header: "分析",field: "slot:analysis",minWidth: "50px",fixed: "left", default: true},
        // {columnsInclude: ['index', 'details'], id: "mskuNum",header: "MSKU数量",field: "mskuNum",minWidth: "100px",fixed: "left", default: true, sortable: true},
        {columnsInclude: ['index', 'details'], id: "salesAmount",header: "销量",field: "salesAmount",minWidth: "120px", align:"right", default: true, summary: true, sortable: true},
        {columnsInclude: ['index', 'details'], id: "refundAmount",header: "退款量",field: "refundAmount",minWidth: "120px", align:"right", default: true, summary: true, sortable: true},
        {columnsInclude: ['index', 'details'], id: "refundAmountRate",header: "退款率",field: "refundAmountRate",minWidth: "120px", align:"right", help:"退款率=退款量/销量", summary: true, sortable: true},
        {columnsInclude: ['index', 'details'], id: "returnAmount",header: "退货量",field: "returnAmount",minWidth: "120px", align:"right", default: true, summary: true, sortable: true},
        {columnsInclude: ['index', 'details'], id: "returnAmountRate",header: "退货率",field: "returnAmountRate",minWidth: "120px", align:"right", help:"退货率=退货量/销量", summary: true, sortable: true},
        {columnsInclude: ['index'],            id: "unsalableQuantity",header: "滞销量",field: "unsalableQuantity",minWidth: "120px", align:"right", default: true, summary: true, sortable: true},
        {columnsInclude: ['index'],            id: "unsalableRate",header: "滞销率",field: "unsalableRate",minWidth: "120px", align:"right", default: true, summary: true, sortable: true},
        {columnsInclude: ['index'],            id: "unsalableAmount",header: "滞销货值",field: "unsalableAmount",minWidth: "120px", align:"right", default: true, summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index'],            id: "totalAmount",header: "总货值",field: "totalAmount",minWidth: "120px", align:"right", default: true, summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "salesMoney",header: "销售额",field: "salesMoney",minWidth: "120px", align:"right", default: true, summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "adsSales",header: "广告销售额",field: "adsSales", minWidth: "120px", align:"right", default: true, summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "asoAs",header: "ASOAS",field: "asoAs",minWidth: "120px", align:"right", default: true, help:"ASOAS=广告销售额/销售额", summary: true, sortable: true},
        {columnsInclude: ['index', 'details'], id: "platformFee",header: "平台费",field: "platformFee",minWidth: "120px", align:"right", summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "compensate",header: "赔偿",field: "compensate",minWidth: "120px", align:"right", summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "totalRefundFee",header: "退款总费用",field: "totalRefundFee",minWidth: "120px", align:"right", summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "returnCompensateCost",header: "退货补回成本",field: "returnCompensateCost",minWidth: "120px", align:"right", summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "purchaseCost",header: "采购成本",field: "purchaseCost",minWidth: "120px", align:"right", default: true, summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "purchaseCostRate",header: "采购成本占比",field: "purchaseCostRate",minWidth: "135px", align:"right", default: true, help:"采购成本占比=采购成本/销售额", summary: true, sortable: true},
        {columnsInclude: ['index', 'details'], id: "arrivalCost",header: "到库成本",field: "arrivalCost",minWidth: "120px", align:"right", default: true, summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "arrivalCostRate",header: "到库成本占比",field: "arrivalCostRate",minWidth: "135px", align:"right", help:"到库成本占比=到库成本/销售额", summary: true, sortable: true},
        {columnsInclude: ['index', 'details'], id: "purchaseRemovalCost",header: "移除成本",field: "purchaseRemovalCost",minWidth: "120px", align:"right", summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "salesCommission",header: "销售佣金",field: "salesCommission",minWidth: "120px", align:"right", summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "fbaDeliveryFee",header: "FBA配送费",field: "fbaDeliveryFee",minWidth: "120px", align:"right", summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "taxes",header: "税金",field: "taxes",minWidth: "120px", align:"right", summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "storageFee",header: "仓储费",field: "storageFee",minWidth: "120px", align:"right", summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "advertisingSpend",header: "广告花费",field: "advertisingSpend",minWidth: "120px", align:"right", default: true, summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "acos",header: "ACOS",field: "acos",minWidth: "120px", align:"right", default: true, help:"ACOS=广告花费/广告销售额", summary: true, sortable: true},
        {columnsInclude: ['index', 'details'], id: "deal",header: "Deal",field: "deal",minWidth: "120px", align:"right", summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "coupon",header: "Coupon",field: "coupon",minWidth: "120px", align:"right", summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "promotionOrderFee",header: "推广订单费用",field: "promotionOrderFee",minWidth: "120px", align:"right", default: true, summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "promotionOtherFeeSon",header: "其他",field: "promotionOtherFeeSon",minWidth: "120px", align:"right", summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "customFee",header: "自定义费用",field: "customFee",minWidth: "120px", align:"right", summary: true, prefix: 'currencySymbol', sortable: true},
        {columnsInclude: ['index', 'details'], id: "salesGrossProfit",header: "销售毛利",field: "salesGrossProfit",minWidth: "120px", align:"right", default: true, prefix: 'currencySymbol', help:"销售毛利=销售额+平台费+赔偿+退款总费用+退货补回成本+采购成本+到库成本+移除成本+销售佣金+FBA配送费+税金", summary: true, sortable: true},
        {columnsInclude: ['index', 'details'], id: "salesGrossProfitRate",header: "销售毛利率",field: "salesGrossProfitRate",minWidth: "135px", align:"right", default: true, help:"销售毛利率=销售毛利/销售额", summary: true, sortable: true},
        {columnsInclude: ['index', 'details'], id: "netSalesGrossProfit",header: "销售净毛利",field: "netSalesGrossProfit",minWidth: "120px", align:"right", prefix: 'currencySymbol', default: true, help:"销售净毛利=销售毛利+广告花费+Deal+Coupon+推广订单费用+仓储费+其他+自定义费用", summary: true, sortable: true},
        {columnsInclude: ['index', 'details'], id: "netSalesGrossProfitRate",header: "销售净毛利率",field: "netSalesGrossProfitRate",minWidth: "135px", align:"right", default: true, help:"销售净毛利率=销售净毛利/销售额", summary: true, sortable: true},
      ],
      cacheOptions: {
        useCache: true,
      }
    };
  },
  methods: {
    // 初始化,重置
    $gjQueryInitParams() {
      return {
        filter: {
          countryMarketValue: {}, // 店铺国家
          categoryIds: null, //品类
          brandId: null, // 品牌
          chargeIds: null, // 销售负责人
          currency: "CNY", // 币种
          date: DATE_SHORTCUTS.lastMonth.date, // 时间搜索
          keyword: { key: "salesMoney", value: null , symbol: 'GREATER'}, // 关键词搜索
        }
      }
    },
    /**
     *
     * @param params 查询条件参数
     * @override queryMixin
     * @returns {{countryMarketValue: *}}
     */
    $gjCacheCallback(params) {
      return {
        countryMarketValue: params.countryMarketValue
      };
    },
    // 搜索
    $gjQuery() {
      // 构造查询参数
      this.loading = true;
      const params = {
        countryCodes: this.filter.countryMarketValue.countryIds, // 国家
        marketIds: this.filter.countryMarketValue.marketIds, // 店铺
        currency: this.filter.currency, // 币种
        chargeIds: this.filter.chargeIds, // 负责人
        startTime: null, // 开始时间
        endTime: null, // 结束时间
        [ this.filter.keyword.key ] : this.filter.keyword.value,
        symbolType: this.filter.keyword.symbol
      }
      params.startTime = convertToFullDate( this.filter.date[0], "yyyy-MM" ) + "-01";
      params.endTime = convertToFullDate( this.filter.date[1], "yyyy-MM" ) + "-01";
      this.globalParams = params;
      this.queryChargePerformanceReportResultList(params);
    },
    // 查询list数据
    async queryChargePerformanceReportResultList(params) {
      this.loading = true;
      try {
        let res = await queryChargePerformanceReportResultList(params);
        this.pageData = res || {}
        this.tableData = res.chargeReportResultVOList || [
          {chargeName: "1%"},
          {chargeName: "2%"},
          {chargeName: "3%"},
        ];
        this.pagination.total = this.tableData.length
      } finally {
        this.loading = false;
      }
    },
    // 分析弹窗
    handleNavigateShop(row) {
      this.$gjCreate(HumanAnalysis, {
        props: {
          human: row.human,
          columns: this.columns,
          filterMap: {
            date: this.filter.date,
            chargeIds: row.chargeId ? [row.chargeId] : null,
            currency: this.filter.currency,
          }
        },
        on: {
          created: () => {
            this.$gjResetPage();
          }
        },
      });
    },
  },
  computed: {
    // 币种
    financeCurrencysOptionMap() {
      let financeCurrencysOptionMap = this._.cloneDeep(financeCurrencysOption)
      financeCurrencysOptionMap.shift()
      return financeCurrencysOptionMap
    },
    columnsMap() {
      return this.columns.filter(item => item.columnsInclude.includes('index') )
    }
  },
  created() {},
};
</script>

<style scoped lang="scss">
.date-picker {
  width: 136px;
}
.analysis-icon {
  font-size: 21px;
  color: #1F6EEF;
  cursor: pointer;
}
</style>
